import { useCallback, useEffect, useState } from 'react';
import { Control, UseFormRegister } from 'react-hook-form';

import { useAtom } from 'jotai';
import InputText from 'src/components/InputText/InputText';
import SelectField from 'src/components/SelectField/SelectField';

import { getChildSchools } from '@/api/getChildSchools';
import { LineUserAtom } from '@/jotai/jotai';
import { schoolGrades } from '@/logics/children/children';
import { UpdateChildFormData } from '@/pages/mypage';
import { Child } from '@/types/child';
import { School } from '@/types/school';

type Props = {
  child: Child | undefined;
  control: Control<UpdateChildFormData>;
  register: UseFormRegister<UpdateChildFormData>;
};

const ExternalContractsForm = ({ child, control, register }: Props) => {
  const [lineUser, _] = useAtom(LineUserAtom);
  const [schools, setSchools] = useState<School[]>([]);
  const fetchSchools = useCallback(async () => {
    try {
      const result = await getChildSchools(
        lineUser?.lineID ?? '',
        lineUser?.accessToken ?? '',
        child?.id ?? 0
      );
      if (result.status === 200) {
        setSchools(result.result);
      }
    } catch (error) {
      console.log('error');
    }
  }, [child]);

  useEffect(() => {
    if (child) {
      fetchSchools();
    }
  }, [child]);

  return (
    <div className="space-y-4 p-4">
      <div className="space-y-4">
        <div className="text-base font-bold">学校</div>
        <SelectField
          name="schoolId"
          control={control}
          items={schools.map((school) => ({
            label: school.name,
            value: school.id.toString(),
          }))}
          required={true}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">学校TEL</div>
        <div className="text-base">{child ? child.school_phone_number : '-'}</div>
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">学年</div>
        <SelectField
          name="schoolGrade"
          control={control}
          items={schoolGrades.map((schoolGrade) => ({
            label: schoolGrade,
            value: schoolGrade,
          }))}
          required={true}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">かかりつけ医（1）</div>
        <InputText
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          type="text"
          {...register('doctorClinicName1')}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">かかりつけ医（1）TEL</div>
        <InputText
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          type="tel"
          {...register('doctorPhoneNumber1')}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">かかりつけ医（1）主治医</div>
        <InputText
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          type="text"
          {...register('doctorName2')}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">かかりつけ医（2）</div>
        <InputText
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          type="text"
          {...register('doctorClinicName2')}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">かかりつけ医（2）TEL</div>
        <InputText
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          type="tel"
          {...register('doctorPhoneNumber2')}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">かかりつけ医（2）主治医</div>
        <InputText
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          type="text"
          {...register('doctorName2')}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">かかりつけ医（3）</div>
        <InputText
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          type="text"
          {...register('doctorClinicName3')}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">かかりつけ医（3）TEL</div>
        <InputText
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          type="tel"
          {...register('doctorPhoneNumber3')}
        />
        <hr className="border-gray-400" />
      </div>

      <div className="space-y-4">
        <div className="text-base font-bold">かかりつけ医（3）主治医</div>
        <InputText
          className="mb-2 block h-14 w-full rounded-md border border-[#1A1A1A] px-3 py-2 text-base focus:border-2 focus:border-yellow-700 disabled:border-solid-gray-420 disabled:bg-solid-gray-50 disabled:text-solid-gray-420 sm:text-sm"
          type="text"
          {...register('doctorName3')}
        />
        <hr className="border-gray-400" />
      </div>
    </div>
  );
};

export default ExternalContractsForm;
